<!-- src\views\components\EditMediaGallery.vue -->
 <template>
    <div class="card mb-4">
        <div class="card-header pb-0 d-flex justify-content-between align-items-center">
            <h4>Select Media</h4>
        </div>

        <div class="card-body px-3 pt-2 pb-4">
            <div class="gallery-grid">
                <div v-for="media in mediaList" :key="media.id" class="media-card"
                    :class="{ 'selected': isSelected(media) }" @click="toggleSelection(media)">
                    <!-- Media Type Tag -->
                    <div class="media-tag" :class="media.type.startsWith('image') ? 'image-tag' : 'video-tag'">
                        {{ media.type.startsWith('image') ? "Image" : "Video" }}
                    </div>

                    <!-- Selected Overlay -->
                    <div class="selected-overlay" v-if="isSelected(media)">✔</div>

                    <!-- Media Preview -->
                    <template v-if="media.type.startsWith('image')">
                        <img :src="media.url" class="media-preview" />
                    </template>
                    <template v-else-if="media.type.startsWith('video')">
                        <video class="media-preview" muted>
                            <source :src="media.url" :type="media.type" />
                        </video>
                    </template>
                </div>
            </div>

            <!-- Confirm Button -->
            <div class="text-center mt-3">
                <button class="btn confirm-btn" @click="confirmSelection">Confirm Selection</button>
            </div>
        </div>
    </div>
</template>

<script>
import MediaDataService from "../../services/MediaDataService.js";
export default {
    data() {
        return {
            mediaList: [],
            selectedMedia: [],
        };
    },
    mounted() {
        // Get previously selected media from URL query
        const selected = this.$route.query.selectedMedia;
        console.log('Selected media from query:', selected);
        if (selected) {
            this.selectedMedia = JSON.parse(selected);
        }
    },
    created() {
        this.getAllMedia();
    },
    methods: {
        isSelected(media) {
            return this.selectedMedia.some((item) => item.id === media.id);
        },
        getAllMedia() {
            MediaDataService.getAll()
                .then(response => {
                    this.mediaList = response.data.map(user => ({
                        id: user.id,
                        url: user.media_url,
                        type: user.type == 1 ? "image/jpeg" : "video/mp4",
                    }));
                })
                .catch(e => {
                    console.log(e);
                });
        },
        toggleSelection(media) {
            const index = this.selectedMedia.findIndex((item) => item.id === media.id);
            if (index === -1) {
                this.selectedMedia.push(media);
            } else {
                this.selectedMedia.splice(index, 1);
            }
        },
        confirmSelection() {
            this.$router.push({
                path: `/edit-playlist/${this.$route.query.playlistId}`,
                query: { selectedMedia: JSON.stringify(this.selectedMedia) ,
                    playlist_name: this.$route.query.playlist_name,
                    user_id: this.$route.query.user_id,
                    user_group_id: this.$route.query.user_group_id,
                    status: this.$route.query.status
                },
            });
        },
    },
};
</script>

<style scoped>
/* Grid Layout - 4 cards per row */
.gallery-grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    /* 4 cards per row */
    gap: 15px;
    padding: 15px;
}

/* Media Card */
.media-card {
    position: relative;
    cursor: pointer;
    border-radius: 10px;
    overflow: hidden;
    transition: transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out;
    background: #ffffff;
    padding: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    border: 2px solid transparent;
}

.media-card:hover {
    transform: scale(1.03);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
}

.media-card.selected {
    border-color: #007bff;
    box-shadow: 0 0 12px rgba(0, 123, 255, 0.5);
}

/* Media Preview */
.media-preview {
    width: 100%;
    height: 140px;
    object-fit: cover;
    border-radius: 5px;
}

/* Selected Overlay */
.selected-overlay {
    position: absolute;
    top: 5px;
    right: 5px;
    background: rgba(0, 128, 0, 0.8);
    color: white;
    font-size: 14px;
    font-weight: bold;
    padding: 5px 8px;
    border-radius: 50%;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.3);
}

/* Media Type Tag */
.media-tag {
    position: absolute;
    bottom: 8px;
    left: 8px;
    padding: 4px 10px;
    font-size: 12px;
    font-weight: bold;
    border-radius: 5px;
    color: white;
}

.image-tag {
    background: linear-gradient(135deg, #007bff, #0056b3);
}

.video-tag {
    background: linear-gradient(135deg, #ff4500, #b22222);
}

/* Confirm Button */
.confirm-btn {
    padding: 12px 24px;
    font-size: 16px;
    background-color: #141727;
    color: white;
    border: none;
    border-radius: 5px;
    transition: background 0.3s ease-in-out;
    font-weight: bold;
}

.confirm-btn:hover {
    background-color: #007bff;
}
</style>